/**
 * 유해위험기계기구(점검) 기본정보(HAZ_BASIC_03) 컬럼 정의
 * HAZ_BASIC_03 화면 전용 컬럼 정의
 */

import { CreateColumn } from '../../../../Services/agGrid/createColumn';
import dayjs from 'dayjs';

/**
 * 유해위험기계기구(점검) 기본정보 컬럼 정의 생성
 * @param {object} props - 컴포넌트 props
 * @returns {Array} 컬럼 정의 배열
 */
export const getColumnDefs1 = (props) => {
  return [
    // 체크박스 컬럼 (NO 컬럼)
    CreateColumn('no', 'NO', 'center', 80, false, false, false, 'checkbox', {
      checkboxProps: {
        DeleteNewRow: props.DeleteNewRow1,
        RestoreRow: props.RestoreRow1,
        gridRef: props.gridRef1,
        rowData: props.rowData1,
        selectedRowNosRef: props.selectedRowNosRef1,
        lastCheckedIndexRef: props.lastCheckedIndexRef1,
        handleRowSelection: props.handleRowSelection1,
      },
      maxWidth: 100,
    }),
    // 채번 컬럼 (숨김)
    CreateColumn('chaebun', '채번', 'left', 110, false, false, true, 'text', {
      minWidth: 110,
    }),
    // 계측기명 컬럼 (필수)
    CreateColumn(
      'instrumentName',
      '계측기명',
      'left',
      120,
      true,
      true,
      false,
      'text',
      {
        minWidth: 120,
        flex: 1,
      }
    ),
    // 계측기 이미지 컬럼 (fileButton)
    CreateColumn(
      'instrumentImageFileName',
      '계측기 이미지',
      'center',
      200,
      false,
      false,
      false,
      'fileButton',
      {
        fileButtonClickHandler: (data, fieldName) => {
          props.PopupClickEvent1?.(data);
        },
        fileButtonFileNameKey: 'instrumentImageFileName',
        fileButtonFilePathKey: 'instrumentImageFilePath',
        minWidth: 200,
      }
    ),
    // Serial NO. 컬럼
    CreateColumn(
      'serialNo',
      'Serial NO.',
      'left',
      120,
      true,
      false,
      false,
      'text',
      {
        minWidth: 120,
        flex: 1,
      }
    ),
    // 수량 컬럼
    CreateColumn('qty', '수량', 'left', 80, true, false, false, 'text', {
      minWidth: 80,
      flex: 1,
    }),
    // 규격 컬럼
    CreateColumn(
      'spec',
      '규격 (형식/용량 등)',
      'left',
      180,
      true,
      false,
      false,
      'text',
      {
        minWidth: 180,
        flex: 1,
      }
    ),
    // 담당부서 컬럼
    CreateColumn(
      'department',
      '담당부서',
      'left',
      120,
      true,
      false,
      false,
      'text',
      {
        minWidth: 120,
        flex: 1,
      }
    ),
    // 담당자 컬럼
    CreateColumn(
      'personInCharge',
      '담당자',
      'left',
      100,
      true,
      false,
      false,
      'text',
      {
        minWidth: 100,
        flex: 1,
      }
    ),
    // 입고일자 컬럼 (date)
    CreateColumn(
      'receivingDate',
      '입고일자',
      'center',
      140,
      true,
      false,
      false,
      'date',
      {
        minWidth: 140,
      }
    ),
    // 검교정 주기 컬럼 (select)
    CreateColumn(
      'measurementCycle',
      '검교정 주기',
      'center',
      240,
      true,
      false,
      false,
      'select',
      {
        minWidth: 240,
        flex: 1,
        selectOptions: ['6개월', '1년', '2년', '직접 입력'],
        headerComponent: (params) => {
          return (
            <div
              style={{
                fontSize: '0.9rem',
                whiteSpace: 'pre-line',
                textAlign: 'center',
                lineHeight: '1.4',
                padding: '8px 4px',
              }}
            >
              검교정 주기{'\n'}(6개월, 1년, 2년, 직접 입력)
            </div>
          );
        },
      }
    ),
    // 검교정일자 컬럼 (date)
    CreateColumn(
      'calibrationDate',
      '검교정일자',
      'center',
      140,
      true,
      false,
      false,
      'date',
      {
        minWidth: 140,
      }
    ),
    // 차기 교정일자 컬럼 (date)
    CreateColumn(
      'nextCalibrationDate',
      '차기 교정일자',
      'center',
      140,
      true,
      false,
      false,
      'date',
      {
        minWidth: 140,
      }
    ),
    // 검교정 기관 컬럼
    CreateColumn(
      'calibrationAgency',
      '검교정 기관',
      'left',
      150,
      true,
      false,
      false,
      'text',
      {
        minWidth: 150,
        flex: 1,
      }
    ),
    // 알람여부 컬럼 (필수, select)
    CreateColumn(
      'alarmYn',
      '알람여부 (Y/N)',
      'center',
      130,
      true,
      true,
      false,
      'select',
      {
        selectOptions: ['Y', 'N'],
        width: 130,
      }
    ),
    // ALARM_ID 컬럼 (숨김)
    CreateColumn(
      'alarmId',
      'ALARM_ID',
      'left',
      100,
      false,
      false,
      true,
      'text',
      {
        minWidth: 100,
      }
    ),
    // 알람일자 컬럼 (편집불가, valueGetter 사용)
    CreateColumn(
      'alarmDate',
      '알람일자',
      'center',
      130,
      false,
      false,
      false,
      'date',
      {
        tooltip: (params) => {
          const alarmYn = params.data?.alarmYn;
          if (alarmYn !== 'Y') {
            return "알림여부가 'Y'일 때만 알람일자가 설정됩니다.";
          }
          return '알림은 차기 교정일자 두 달 전에 발송됩니다.';
        },
        cellClass: 'none-editable-cell',
        width: 130,
        customCellStyle: {
          backgroundColor: '#f5f5f5',
          color: '#555',
          fontStyle: 'italic',
          cursor: 'not-allowed',
        },
        valueGetter: (params) => {
          const alarmYn = params.data?.alarmYn;
          const nextCalibrationDate = params.data?.nextCalibrationDate;

          if (alarmYn !== 'Y') return null;
          if (!nextCalibrationDate) return null;

          const date = new Date(nextCalibrationDate);
          if (isNaN(date.getTime())) return null;

          date.setMonth(date.getMonth() - 2);
          return date.toISOString();
        },
        valueFormatter: (params) => {
          if (!params.value) return '';
          return dayjs(params.value).format('YYYY-MM-DD');
        },
      }
    ),
    // 비고 컬럼
    CreateColumn('remark', '비고', 'left', 150, true, false, false, 'text', {
      minWidth: 150,
      flex: 1,
    }),
    // 계측기 이미지 저장명 컬럼 (숨김)
    CreateColumn(
      'instrumentImageSaveName',
      '계측기 이미지 저장명',
      'left',
      200,
      false,
      false,
      true,
      'text',
      {
        flex: 1,
      }
    ),
    // 계측기 이미지 파일 경로 컬럼 (숨김)
    CreateColumn(
      'instrumentImageFilePath',
      '계측기 이미지 파일 주소',
      'left',
      200,
      false,
      false,
      true,
      'text',
      {
        flex: 1,
      }
    ),
    // 미리보기 파일 경로 컬럼 (숨김)
    CreateColumn(
      'previewFilePath',
      '미리보기 파일 경로',
      'left',
      200,
      false,
      false,
      true,
      'text',
      {
        flex: 1,
      }
    ),
  ];
};

const columnDefs = {
  getColumnDefs1,
};

export default columnDefs;
